import { render, staticRenderFns } from "./dutyArrangement.vue?vue&type=template&id=791738fc&scoped=true"
import script from "./dutyArrangement.vue?vue&type=script&lang=js"
export * from "./dutyArrangement.vue?vue&type=script&lang=js"
import style0 from "./dutyArrangement.vue?vue&type=style&index=0&id=791738fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791738fc",
  null
  
)

export default component.exports